import { render, staticRenderFns } from "./RecepcionFacturaDetalleComponent.vue?vue&type=template&id=8bbbb372&scoped=true&"
import script from "./RecepcionFacturaDetalleComponent.vue?vue&type=script&lang=js&"
export * from "./RecepcionFacturaDetalleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbbb372",
  null
  
)

export default component.exports